import {
  ROOT_CATALOG_URL,
  ROOT_EDITORS_STAFF_URL,
} from '@/shared/constants/urlConstants';
import {
  LAWYER_TYPE_LAWYER,
  LAWYER_TYPE_ADVOCATE,
} from '@/shared/constants/lawyerTypeConstants';
import {
  ORGANIZATION_TYPE_CLUB,
  ORGANIZATION_TYPE_BUREAU,
} from '@/shared/constants/organizationTypeConstants';
import { buildCatalogUrl } from '@/shared/utils/buildCatalogUrl';
import { buildFullName } from '@/shared/utils/buildFullName';

import type { ILawyerCardInfo } from '@/entities/lawyer/@x/journal';
import type { IJournalArticleUser } from '@/entities/journal/model/types';

export interface ArticleAuthorInfo {
  fullName: string;
  jobTitle: string;
  profileLink: string;
}

const CHIEF_EDITOR_PROFILE_LINK = `${ROOT_EDITORS_STAFF_URL}igor-lesovskih/`;

export const buildAuthorInfo = (
  lawyer: ILawyerCardInfo | null | undefined,
  user?: IJournalArticleUser | null,
): ArticleAuthorInfo | null => {
  if (!lawyer) {
    if (!user) return null;
    const fullName = [user.name, user.surname].filter(Boolean).join(' ');
    return {
      fullName,
      jobTitle: '',
      profileLink: CHIEF_EDITOR_PROFILE_LINK,
    };
  }

  const companyId = lawyer.company_id;

  const fullName = lawyer.company?.name ? lawyer.company.name : buildFullName(lawyer);

  const jobTitle =
    lawyer.role === LAWYER_TYPE_ADVOCATE && !companyId ? 'Адвокат' : 'Юрист';

  const region = lawyer.addresses?.length ? lawyer.addresses[0]?.city?.slug : '';
  const isIndividual =
    (lawyer.role === LAWYER_TYPE_LAWYER || lawyer.role === LAWYER_TYPE_ADVOCATE) &&
    !companyId;
  const isOrganization =
    (lawyer.role === ORGANIZATION_TYPE_CLUB ||
      lawyer.role === ORGANIZATION_TYPE_BUREAU) &&
    Boolean(companyId);

  const profileLink =
    isIndividual || isOrganization
      ? buildCatalogUrl({
          segments: [
            'geo',
            region,
            isIndividual ? 'lawyers' : 'organizations',
            lawyer.slug,
          ],
        })
      : ROOT_CATALOG_URL;

  return { fullName, jobTitle, profileLink };
};
